import { render, staticRenderFns } from "./FreeTextDashboardItem.vue?vue&type=template&id=01619378&scoped=true"
import script from "./FreeTextDashboardItem.vue?vue&type=script&lang=js"
export * from "./FreeTextDashboardItem.vue?vue&type=script&lang=js"
import style0 from "./FreeTextDashboardItem.vue?vue&type=style&index=0&id=01619378&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01619378",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pikkle/Dev/eM+/muse/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01619378')) {
      api.createRecord('01619378', component.options)
    } else {
      api.reload('01619378', component.options)
    }
    module.hot.accept("./FreeTextDashboardItem.vue?vue&type=template&id=01619378&scoped=true", function () {
      api.rerender('01619378', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dashboard/Items/FreeTextDashboardItem.vue"
export default component.exports